module.exports = __webpack_public_path__ + "static/media/IMG_2710.aff6593f.jpg";